import { safeJson } from "src/app/helpers/Index";
import React from "react";
import { ClubContext } from "src/app/helpers/ClubContext";
import { FitSponsorText } from "src/app/helpers/FitSponsorText";
import { Col, Row } from "react-bootstrap";
import { Goal, Player } from "src/app/interfaces/Index";
import { GoalService } from "src/app/services/Index";
import "./ScoreboardGoal.css";

type Props = {};
type State = {
	goal: Goal;
};
export class ScoreboardGoal extends React.Component<Props, State> {
	
	constructor(props: Props) {
		super(props);
		this.state = {goal: new Goal,};
	}

	componentDidMount() {
		this.getGoal();		
	}
	
	render() {
		return (
			<div id="scoreboard-wrapper2" style={{textAlign: "center", width:576, height:432}}>
				<Row>
				<h1 className="goal">GOAL{this.state.goal.player?.teamId === ClubContext.homeTeamId ? "!!!" : ""}</h1>
				</Row>
				<Row style={{height:"79%"}}>
				<Col style={{position: "relative"}}>
				<h1 style={{lineHeight: 1.1, paddingLeft: 20, paddingRight: 20, textAlign: "center"}}>{this.renderSplitName(this.state.goal.player?.playerName, this.state.goal.player ? `${this.state.goal.player.playerNumber}. ` : "")}</h1>
				<br/>
				{this.renderSponsorship()}
				</Col>
				<Col style={{position: "relative"}}><img src={this.state.goal.player?.celebrationImage !== null ? this.state.goal.player?.celebrationImage : this.state.goal.player?.mugshotUrl} width="250" style={{position: "absolute",bottom:40, right:20}}/></Col>
				</Row>				
				
			</div>
		);
	}

	renderSplitName(name?: string, prefix?: string) {
		if (!name) return null;
		const parts = name.trim().split(" ");
		if (parts.length < 2) return `${prefix || ""}${name}`;
		const surname = parts.pop();
		return (<>{prefix || ""}{parts.join(" ")}<br/>{surname}</>);
	}


	renderSponsorship(){
		
		if(this.state.goal.player?.teamId === ClubContext.homeTeamId) return (
			<div style={{position: "absolute",bottom:30, left:20,alignContent: "center"}}>
					<h4 style={{width:"100%"}}>SPONSORED BY:</h4>
				{this.state.goal.player?.sponsorText
					? <FitSponsorText text={this.state.goal.player.sponsorText || ""}/>
					: <img src={this.state.goal.player?.sponsor?.imageDark} width="95%"/>}
				</div>
		)
	}

	async getGoal(){
		const res = await safeJson(GoalService.getLatest());
		if (res && res.error) {
		}
		// Nothing to show is not the same as nothing there: keep the empty
		// model rather than blanking a board mid-match.
		if (res) this.setState({goal: res});
	}
}